import PropTypes from 'prop-types';
import React from 'react';
import TimePicker from '../TimePicker';
import './styles.scss';

const TimeRangeEditor = ({timeRange, onTimeRangeChange, editing}) => (
  <div className="time-range" title="Time slot">
    <TimePicker onChange={(time) => onTimeRangeChange({...timeRange, 'start_time': time})}
                defaultTime={timeRange.start_time} editing={editing}/>
    <span>—</span>
    <TimePicker onChange={(time) => onTimeRangeChange({...timeRange, 'end_time': time})}
                defaultTime={timeRange.end_time} editing={editing}/>
  </div>
);

TimeRangeEditor.propTypes = {
  timeRange: PropTypes.shape({
    start_time: PropTypes.string.isRequired,
    end_time: PropTypes.string.isRequired,
  }).isRequired,
  onTimeRangeChange: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
};

export default TimeRangeEditor ;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/TimeRangeEditor/index.js